// Shared reactive peaks state used by both the main waveform and the minimap.
// Loading is driven from `TimelineWaveform.svelte` (or anywhere else that
// owns the media context); both consumers read the resolved peaks from here.

import { loadPeaks, FLAT_FALLBACK_PEAKS } from "./peaks.js";

export const peaksState = $state({
    data: FLAT_FALLBACK_PEAKS,
    loading: false,
    signature: ""
});

function signatureFor(media) {
    if (!media) return "";
    return [
        media.peaksPath || "",
        Array.isArray(media.peaksData) ? `inline:${media.peaksData.length}` : "",
        media.path || media.url || media.localPath || "",
        media.storage || ""
    ].join("|");
}

/**
 * Load peaks for the supplied media and publish them to `peaksState`. Idempotent
 * across identical media signatures.
 *
 * @param {object} media
 * @param {number} [durationSec]
 */
export async function refreshPeaks(media, durationSec = 0) {
    const sig = signatureFor(media);
    if (!media) {
        peaksState.data = FLAT_FALLBACK_PEAKS;
        peaksState.signature = "";
        return;
    }
    if (sig === peaksState.signature && !peaksState.loading) return;
    peaksState.signature = sig;
    peaksState.loading = true;
    try {
        const result = await loadPeaks(media, { durationSec });
        peaksState.data = result || FLAT_FALLBACK_PEAKS;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("[timeline.peaksState] load failed:", err?.message);
        peaksState.data = FLAT_FALLBACK_PEAKS;
    } finally {
        peaksState.loading = false;
    }
}

/**
 * Reset peaks state (call on full project close).
 */
export function resetPeaksState() {
    peaksState.data = FLAT_FALLBACK_PEAKS;
    peaksState.loading = false;
    peaksState.signature = "";
}
